import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SofaIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SofaIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.7129 17.42C19.4046 17.42 19.1537 17.169 19.1537 16.8608V16.1193H6.8263V16.8608C6.8263 17.169 6.57532 17.42 6.26709 17.42C5.95886 17.42 5.70788 17.169 5.70788 16.8608V16.1193H4.96641C3.94056 16.1193 3.10652 15.2843 3.10652 14.2585V10.7887C3.10652 9.76287 3.94056 8.92836 4.96641 8.92836C5.22216 8.9317 5.47504 8.98753 5.70788 9.09059V9.05385C5.70788 7.55325 6.50088 6.75977 8.00196 6.75977H17.977C19.4991 6.75977 20.2711 7.53178 20.2711 9.05385V9.09011C20.5078 8.98419 20.7616 8.92836 21.0135 8.92836C22.0394 8.92836 22.8744 9.76288 22.8744 10.7887V14.2585C22.8744 15.2843 22.0384 16.1193 21.0097 16.1193H20.2711V16.8608C20.2711 17.169 20.0211 17.42 19.7129 17.42ZM4.96641 10.0472C4.55798 10.0472 4.22494 10.3798 4.22494 10.7887V14.2585C4.22494 14.6674 4.55798 14.9999 4.96641 14.9999H21.0097C21.421 14.9999 21.756 14.6674 21.756 14.2585V10.7887C21.756 10.3798 21.4229 10.0472 21.0135 10.0472C20.6042 10.0472 20.2711 10.3798 20.2711 10.7887V13.0833H5.70789V10.7887C5.70789 10.3798 5.37484 10.0472 4.96641 10.0472ZM19.1537 11.9639V9.05384C19.1537 8.16398 18.8674 7.87865 17.977 7.87865H8.00197C7.11258 7.87865 6.8263 8.16398 6.8263 9.05384V11.9639H19.1537Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.201 8.95445C20.9066 8.95445 20.6105 9.03283 20.3419 9.18201V8.98311C20.3419 7.49163 19.5856 6.73535 18.0939 6.73535H7.88584C6.39408 6.73535 5.6378 7.49163 5.6378 8.98311V9.18229C5.37597 9.03733 5.08043 8.95867 4.7787 8.95445C3.78419 8.95445 2.9751 9.76354 2.9751 10.7583V14.3091C2.9751 15.3039 3.78419 16.1132 4.7787 16.1132H5.6378V16.9723C5.6378 17.2328 5.84962 17.4446 6.11033 17.4446C6.37104 17.4446 6.58286 17.2328 6.58286 16.9723V16.1132H19.3968V16.9723C19.3968 17.2328 19.6087 17.4446 19.8694 17.4446C20.1301 17.4446 20.3419 17.2328 20.3419 16.9723V16.1132H21.1965C22.1938 16.1132 23.0052 15.3039 23.0052 14.3091V10.7583C23.0052 9.76354 22.1961 8.95445 21.201 8.95445ZM6.58287 12.0613V8.9831C6.58287 8.02118 6.92392 7.68013 7.88584 7.68013H18.0939C19.0558 7.68013 19.3968 8.02118 19.3968 8.9831V12.0613H6.58287ZM20.3419 13.0064V10.7583C20.3419 10.285 20.7273 9.8995 21.201 9.8995C21.6747 9.8995 22.0601 10.2849 22.0601 10.7583V14.3091C22.0601 14.7827 21.6724 15.1682 21.1965 15.1682H4.77871C4.30562 15.1682 3.92017 14.7827 3.92017 14.3091V10.7583C3.92017 10.285 4.30561 9.8995 4.77871 9.8995C5.25237 9.8995 5.63781 10.2849 5.63781 10.7583V13.0064H20.3419Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SofaIcon;
